import { A as f } from "./constants-DV0QHdfI.js";
const s = "m_phdid", m = "m_phsid";
function u(e) {
  var t;
  const n = e ?? new URL(window.location.href);
  if (n.hostname !== "app.manifold.xyz" && n.hostname !== "gallery.manifold.xyz")
    return;
  if (n.hostname === "gallery.manifold.xyz")
    return "marketplace";
  const a = n.pathname.split("/")[1];
  return (t = Object.values(f).find((o) => o.slug === a)) == null ? void 0 : t.name;
}
function d() {
  var n;
  const e = {
    source: ""
  };
  if (!((n = window == null ? void 0 : window.location) != null && n.href))
    return e;
  try {
    const a = new URL(window.location.href);
    a.hostname === "app.manifold.xyz" ? (e.source = "collector_app", e.campaign = u(a)) : a.hostname === "manifold.gallery" ? e.source = "manifold_gallery" : a.hostname === "gallery.manifold.xyz" ? e.source = "manifold_marketplace" : a.hostname === "localhost" || a.hostname.includes("localhost:") ? e.source = "" : e.source = a.hostname;
  } catch (a) {
    console.error(a);
  } finally {
    return e;
  }
}
function p(e, n) {
  const a = d(), i = e.source || a.source, t = e.campaign || a.campaign, o = {
    source: i,
    campaign: t,
    medium: e.medium,
    [s]: n == null ? void 0 : n.get_distinct_id(),
    [m]: n == null ? void 0 : n.get_session_id()
  }, l = Object.entries(o).filter(([, r]) => !!r);
  return l.length === 0 ? "" : "?" + l.map(([r, c]) => r.startsWith("m_") ? `${r}=${c}` : `utm_${r}=${c}`).join("&");
}
const y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PH_DID_QUERY_KEY: s,
  PH_SID_QUERY_KEY: m,
  buildQueryString: p,
  extrapolateApp: u,
  extrapolateTrackers: d
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as P,
  m as a,
  d as b,
  p as c,
  u as e,
  y as i
};
